import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Child } from '../models/interfaces/child.interface';
import { environment } from '../../config/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ChildService {
  private readonly path = 'child';

  constructor(private httpClient: HttpClient) {}

  create(child: Child): Observable<Child> {
    return this.httpClient.post<Child>(
      `${environment.api.baseUrl}/${this.path}`,
      child
    );
  }

  findByName(firstName: string, idSchool?: string): Observable<Child[]> {
    return this.httpClient.get<Child[]>(
      `${environment.api.baseUrl}/${this.path}/q`,
      {
        params: {
          firstname: `${firstName}`,
          idSchool: `${idSchool}`
        },
      }
    );
  }

  getById(id: string): Observable<Child> {
    return this.httpClient.get<Child>(
      `${environment.api.baseUrl}/${this.path}/${id}`
    );
  }

  addParent(idChild: string, idUser: string): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.api.baseUrl}/${this.path}/${idChild}/parent`,
      { id: idUser }
    );
  }

   removeParent(idChild: string, idUser: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.api.baseUrl}/${this.path}/${idChild}/parent/${idUser}`
    );
  }

  /**
   * @deprecated
   * Remover também na API
   */
   addClassRoom(idChild: string, idClassRoom: string) {
    return this.httpClient.put<void>(
      `${environment.api.baseUrl}/${this.path}/${idChild}/classRoom`,
      { id: idClassRoom }
    );
  }

  /**
   * @deprecated
   * Remover também na API
   */
   removeClassRoom(idChild: string, idClassRoom: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.api.baseUrl}/${this.path}/${idChild}/classRoom/${idClassRoom}`
    );
  }

  findByParent(idUser: string): Observable<Child[]> {
    return this.httpClient.get<Child[]>(
      `${environment.api.baseUrl}/${this.path}/parents`,
      {
        params: { id: idUser },
      }
    );
  }

  public update(child: Child): Observable<Child> {
    return this.httpClient.put<Child>(
      `${environment.api.baseUrl}/${this.path}/${child.id}`,
      child
    );
  }
}
